import React from 'react'


export default function Womenchild1() {
    return (
       
    <div className="section_heading">
        <h1>Kalpataru <span>Women&childcare</span> Treatment</h1>
      
  
      </div>

       
    )
}